import { makeStyles } from "@material-ui/core";

export default makeStyles((theme) => ({
  resizeElement: {
    position: "absolute",
    left: 0,
    top: 0,
    height: "100%",
    width: 24,
    borderLeft: `2px solid ${theme.palette.primary.main}`,
    transition: "0.3s all",
    cursor: "col-resize",
    opacity: 0,
    zIndex: 1000,
    "&:hover": {
      opacity: 1,
    },
  },
  resizeTooltip: {
    position: "absolute",
    left: 10,
    width: 46,
    height: 27,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    transition: "0.3s opacity",
    borderRadius: 4,
    fontSize: 10,
    color: theme.palette.tooltipText.main,
    background: theme.palette.tooltipBackground.main,
    zIndex: 1000,
  },
}));
